export default "__VITE_ASSET__ihHoHEiU__"